/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Chat_Composer_PlaceholderInputs */

const en_case_chat_composer_placeholder = /** @type {(inputs: Case_Chat_Composer_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type or paste conversation content…`)
};

const pt_br2_case_chat_composer_placeholder = /** @type {(inputs: Case_Chat_Composer_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite ou cole o conteúdo da conversa…`)
};

/**
* | output |
* | --- |
* | "Type or paste conversation content…" |
*
* @param {Case_Chat_Composer_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_chat_composer_placeholder = /** @type {((inputs?: Case_Chat_Composer_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Chat_Composer_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_chat_composer_placeholder(inputs)
	return pt_br2_case_chat_composer_placeholder(inputs)
});